import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import AnalyticsTracker from './components/AnalyticsTracker';
import Home from './pages/Home';
import WhatWeDo from './pages/WhatWeDo';
import Concepts from './pages/Concepts';
import Faq from './pages/Faq';
import About from './pages/About';
import Contact from './pages/Contact';
import './styles/global.scss';
import { initGA } from './utils/googleAnalytics/google-analytics';
import tracker from './utils/openReplay';

const App = () => {
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
        tracker.start();
        initGA(); // only once in production
    }
  }, []);
    
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <AnalyticsTracker />
        <div className="App">
          <Header />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/what-we-do" element={<WhatWeDo />} />
              <Route path="/concepts" element={<Concepts />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
};

export default App;
